import { Box, Breadcrumbs, Divider, Grid2, Paper, Tab, Tabs, Typography } from '@mui/material';
import { NavigateNext, PersonOutline, TuneOutlined, FolderOpenOutlined } from '@mui/icons-material';
import { useContext, useEffect } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import ProfileSettings from './ProfileContent';
import PreferencesConfig from '../Configurations/Preferences/index';
import ConsultantDocuments from '../consultants/consultant-view/ConsultantDocuments';
import { activityStatus, userCats } from '../../../helpers/appstate';
import { AppContext } from '../../../store/AppContext';
import UserSettingDetail from './user-setting/UserSettingDetail';

const UserSettingScreen = withRouter(({ props, location, history }) => {
  const { state } = useContext(AppContext);
  const authUser = state?.auth?.result?.data || {};
  const userId = props?.userId || authUser.userId;
  const userCategory = props?.userCategory || authUser.userCategory;
  const status = props?.status || authUser.status;

  const searchParams = new URLSearchParams(location?.search);
  const tab = searchParams.get('tab') || '';

  const tabs = [
    {
      value: 'profile',
      label: 'Profile',
      icon: <PersonOutline sx={{ fontSize: 18 }} />,
      isVisible: true,
      component: () => <ProfileSettings />,
    },
    {
      value: 'configuration',
      label: 'Preferences',
      icon: <TuneOutlined sx={{ fontSize: 18 }} />,
      isVisible: status === activityStatus.ACTIVE && userCategory !== userCats.EDM,
      component: () => <PreferencesConfig />,
    },
    {
      value: 'documents',
      label: 'Documents',
      icon: <FolderOpenOutlined sx={{ fontSize: 18 }} />,
      isVisible: userCategory === userCats.CONSULTANT,
      component: () => (
        <ConsultantDocuments userCategory={userCategory} consultantUserId={userId} />
      ),
    },
  ].filter((x) => x.isVisible);

  const activeTab = tabs.find((x) => x.value === tab) || tabs[0];

  useEffect(() => {
    if (!tab) {
      const newParam = new URLSearchParams(location?.search);
      newParam.set('tab', tabs[0]?.value);
      history.replace({ search: newParam.toString() });
    }
  }, []);

  const handleTabChange = (ev, val) => {
    const newParam = new URLSearchParams(location?.search);
    newParam.set('tab', val);
    history.push({ search: newParam.toString() });
  };

  return (
    <Box sx={{ p: { xs: 1, md: 3 }, bgcolor: '#F4F6F8', minHeight: '100vh' }}>
      {userCategory === userCats.EDM && (
        <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={{ mb: 3 }}>
          <Link to="/settings" style={{ textDecoration: 'none' }}>
            <Typography variant="body2" color="primary" fontWeight={600}>
              Settings
            </Typography>
          </Link>
          <Typography variant="body2" color="text.secondary">
            My Account
          </Typography>
        </Breadcrumbs>
      )}

      <Grid2 container spacing={3} alignItems="flex-start">
        {/* LEFT: profile summary */}
        <Grid2 size={{ lg: 4, md: 5, sm: 12, xs: 12 }}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: '20px',
              border: '1px solid',
              borderColor: 'divider',
              overflow: 'hidden',
              position: { md: 'sticky' },
              top: '20px',
              bgcolor: '#fff',
            }}
          >
            <UserSettingDetail userId={userId} />
          </Paper>
        </Grid2>

        {/* RIGHT: tabs */}
        <Grid2 size={{ lg: 8, md: 7, sm: 12, xs: 12 }}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: '20px',
              border: '1px solid',
              borderColor: 'divider',
              minHeight: '60vh',
              bgcolor: '#fff',
            }}
          >
            <Box sx={{ px: 2, pt: 1 }}>
              <Tabs
                value={activeTab?.value}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
                  '& .MuiTab-root': {
                    textTransform: 'none',
                    fontWeight: 700,
                    fontSize: '0.875rem',
                    minHeight: 50,
                    color: 'text.secondary',
                    '&.Mui-selected': { color: 'primary.main' },
                  },
                }}
              >
                {tabs.map((t) => (
                  <Tab key={t.value} label={t.label} value={t.value} icon={t.icon} iconPosition="start" />
                ))}
              </Tabs>
            </Box>
            <Divider />
            <Box sx={{ p: { xs: 2, md: 3 } }}>{activeTab?.component()}</Box>
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
});

export default UserSettingScreen;
